import axios from "axios";
import React, { useState, useEffect } from "react";
import CreaNivel from "../Modals/crear/CreaAutoevaluacion/CreaNivelDirectivo";
import Cookies from "universal-cookie";

function Titulo52SeccionA(props) {
  const cookies = new Cookies();
  const [list, setList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const mostrarAcciones =
    cookies.get("tipo_Usuario") == 2 &&
    window.location.href.includes("ProcesoAutoevaluacion");

  useEffect(() => {
    obtenerLista();
  }, [props.idSolicitud]);

  const obtenerLista = () => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: `https://suadesarrollo.azurewebsites.net/api/ObtenerNivelDirectivoPorSolicitudId?SolicitudId=${props.idSolicitud}`,
    })
      .then((response) => {
        setList(response.data || []);
      })
      .catch(console.log);
  };

  // 🔹 AGREGAR REGISTRO SIN RECARGAR
  const onRegistroCreado = (nuevo) => {
    setList((prev) => [...prev, nuevo]);
  };

  // 🔹 ELIMINAR SIN RECARGAR
  const eliminarRegistro = (id) => {
    if (!window.confirm("¿Estás seguro de eliminar este registro?")) return;

    axios({
      method: "delete",
      url: `https://suadesarrollo.azurewebsites.net/api/eliminarNivelDirectivoPorId?Id=${id}`,
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      data: {
        tipoAccion: "Eliminación de registro Nivel Directivo",
        idUsuario: cookies.get("id"),
      },
    })
      .then(() => {
        setList((prev) => prev.filter((item) => item.id !== id));
      })
      .catch(() => alert("Error al eliminar el registro"));
  };

  // 🔹 PAGINACIÓN
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = list.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(list.length / itemsPerPage);

  return (
    <div className="container-fluid">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            Integrantes del Nivel Directivo
          </h6>
        </div>

        <div className="card-body">
          {mostrarAcciones && (
            <CreaNivel
              idSolicitud={props.idSolicitud}
              onRegistroCreado={onRegistroCreado}
            />
          )}

          <hr />

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Nombre</th>
                  <th>Cargo</th>
                  <th>Profesión</th>
                  <th>SolicitudId</th>
                  {mostrarAcciones && <th>Acción</th>}
                </tr>
              </thead>
              <tbody>
                {currentItems.length > 0 ? (
                  currentItems.map((item) => (
                    <tr key={item.id || Math.random()}>
                      <td>{item.id}</td>
                      <td>{item.nombre}</td>
                      <td>{item.cargo}</td>
                      <td>{item.profesion}</td>
                      <td>{item.solicitudId}</td>
                      {mostrarAcciones && (
                        <td>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => eliminarRegistro(item.id)}
                          >
                            Eliminar
                          </button>
                        </td>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No hay registros
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && (
            <div className="pagination mt-3">
              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i}
                  className={`btn btn-sm mx-1 ${
                    currentPage === i + 1
                      ? "btn-primary"
                      : "btn-outline-primary"
                  }`}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Titulo52SeccionA;
